import { createAsyncThunk } from "@reduxjs/toolkit";
import { CreateMixPlatformInterface } from "../../../entities/Tenant";
import { AxiosError } from "axios";
import { PlatformService } from "../../../services/PlatformService";
import { RootState } from "../../../store/store";

export const createMixFromPlatform = createAsyncThunk<
  boolean,
  CreateMixPlatformInterface,
  { rejectValue: AxiosError }
>(
  "mix/createMixFromPlatform",
  async (
    payload: CreateMixPlatformInterface,
    { rejectWithValue, getState },
  ) => {
    try {
      const state = getState() as RootState;
      const linkRedirect = state.tenant.data.credentials?.linkRedirect;

      const response = await PlatformService.createMix(payload);
      window.location.href = `${linkRedirect}&mixId=${response.id}&qty=${response.numberOfGlasses}`;
      return true;
    } catch (e: any) {
      return rejectWithValue(e.message as AxiosError);
    }
  },
);
